
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import EcoPilot from '../../../components/feature/EcoPilot';
import { useState } from 'react';
import Button from '../../../components/base/Button';
import Card from '../../../components/base/Card';
import QuoteModal from '../../../components/feature/QuoteModal';

export default function TSRSPage() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <>
      <Header />
      <main className="min-h-screen">
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{ 
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=Turkish%20sustainability%20reporting%20standards%20TSRS%20documentation%20with%20Turkish%20business%20professionals%20in%20modern%20office%20environment%2C%20corporate%20sustainability%20compliance%20and%20national%20standards&width=1200&height=600&seq=603&orientation=landscape)' 
          }}
        >
          <div className="absolute inset-0 bg-blue-900/80"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl font-bold text-white mb-6 animate-in fade-in slide-in-from-bottom-8 duration-1000">
                TSRS Sürdürülebilirlik Raporu
              </h1>
              <p className="text-xl text-blue-100 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
                Türkiye Sürdürülebilirlik Raporlama Standartları'na uygun raporlama ile yerel gereksinimlerinizi karşılayın. Borsa İstanbul ve yasal düzenlemelere tam uyum sağlayın.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
                <Button 
                  size="lg"
                  onClick={() => setIsQuoteModalOpen(true)}
                  className="whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-file-text-line"></i>
                  </div>
                  Teklif Al
                </Button>
                <Button 
                  size="lg" 
                  variant="outline"
                  onClick={() => window.open('https://calendly.com/ecoventra', '_blank')}
                  className="border-white text-white hover:bg-white hover:text-blue-700 whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center mr-2">
                    <i className="ri-calendar-line"></i>
                  </div>
                  Ücretsiz Konsültasyon
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Key Features */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                TSRS Raporlama Hizmetlerimiz
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Türkiye'ye özel sürdürülebilirlik raporlama standartları için profesyonel hizmetler
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: 'ri-flag-line',
                  title: 'TSRS Standartları',
                  description: 'Türkiye özel raporlama standartlarına tam uyumluluk'
                },
                {
                  icon: 'ri-government-line',
                  title: 'Yasal Uyumluluk',
                  description: 'Borsa İstanbul ve yasal gereksinimler'
                },
                {
                  icon: 'ri-translate-2',
                  title: 'Türkçe Raporlama',
                  description: 'Yerel paydaşlar için Türkçe kapsamlı raporlar'
                },
                {
                  icon: 'ri-bank-line',
                  title: 'BİST Avantajı',
                  description: 'Borsa İstanbul sürdürülebilirlik endeksi hazırlığı'
                }
              ].map((feature, index) => (
                <Card key={index} className="p-6 text-center hover:shadow-lg transition-shadow duration-300">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${feature.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-sm">{feature.description}</p>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                TSRS Raporlama Sürecimiz
              </h2>
              <p className="text-xl text-gray-600">
                10-14 haftalık yerel standartlara uygun raporlama
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  step: '1',
                  title: 'Yasal Gereksinim Analizi',
                  description: 'TSRS ve BİST gereksinimlerinin değerlendirilmesi',
                  duration: '1-2 hafta'
                },
                {
                  step: '2',
                  title: 'Yerel Stakeholder Analizi',
                  description: 'Türkiye özel paydaş beklentilerinin belirlenmesi',
                  duration: '2-3 hafta'
                },
                {
                  step: '3',
                  title: 'TSRS Veri Toplama',
                  description: 'Standartlara uygun veri derleme ve analiz',
                  duration: '4-5 hafta'
                },
                {
                  step: '4',
                  title: 'Türkçe Rapor Hazırlama',
                  description: 'TSRS formatında profesyonel rapor yazımı',
                  duration: '3-4 hafta'
                }
              ].map((process, index) => (
                <div key={index} className="relative">
                  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">
                        {process.step}
                      </div>
                      <div className="text-sm text-blue-600 font-medium">{process.duration}</div>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{process.title}</h3>
                    <p className="text-gray-600 text-sm">{process.description}</p>
                  </div>
                  {index < 3 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                      <i className="ri-arrow-right-line text-2xl text-blue-300"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  TSRS Raporlamasının Faydaları
                </h2>
                <div className="space-y-6">
                  {[
                    {
                      icon: 'ri-shield-check-line',
                      title: 'Yasal Uyumluluk',
                      description: 'Türkiye yasal gereksinimleri ve düzenlemelerine tam uyum'
                    },
                    {
                      icon: 'ri-map-pin-line',
                      title: 'Yerel Tanınırlık',
                      description: 'Türkiye pazarında güvenilirlik ve tanınırlık'
                    },
                    {
                      icon: 'ri-line-chart-line',
                      title: 'BİST Sürdürülebilirlik Endeksi',
                      description: 'Borsa İstanbul endeksine dahil olma avantajı'
                    },
                    {
                      icon: 'ri-gift-line',
                      title: 'Devlet Teşvikleri',
                      description: 'Sürdürülebilirlik teşviklerinden yararlanma'
                    }
                  ].map((benefit, index) => (
                    <div key={index} className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${benefit.icon} text-xl text-blue-600`}></i>
                      </div>
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">{benefit.title}</h3>
                        <p className="text-gray-600">{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=Turkish%20business%20professionals%20celebrating%20TSRS%20sustainability%20reporting%20success%20with%20Borsa%20Istanbul%20recognition%20and%20national%20compliance%20certificates%20in%20modern%20corporate%20office&width=600&height=400&seq=604&orientation=landscape"
                  alt="TSRS Raporlama Faydaları"
                  className="rounded-2xl shadow-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              TSRS Sürdürülebilirlik Raporunuz İçin Başlayın
            </h2>
            <p className="text-xl text-blue-100 mb-10">
              Türkiye özel gereksinimleriniz için uzman desteği alın
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg"
                onClick={() => setIsQuoteModalOpen(true)}
                className="bg-white text-blue-600 hover:bg-gray-100 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-file-text-line"></i>
                </div>
                Detaylı Teklif Al
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                onClick={() => window.open('https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, TSRS sürdürülebilirlik raporu hakkında bilgi almak istiyorum.', '_blank')}
                className="border-white text-white hover:bg-white hover:text-blue-600 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-whatsapp-line"></i>
                </div>
                WhatsApp ile İletişim
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppButton />
      <EcoPilot />
      
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </>
  );
}
